import React from 'react'

export default (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 6" {...props}>
			<rect width="8" height="6" fill="#dc143c"/>
			<rect width="8" height="3" fill="#fff"/>
		</svg>
	)
}

